import { render, staticRenderFns } from "./CommentPanelCreator.vue?vue&type=template&id=e98a296a&scoped=true"
import script from "./CommentPanelCreator.vue?vue&type=script&lang=ts"
export * from "./CommentPanelCreator.vue?vue&type=script&lang=ts"
import style0 from "./CommentPanelCreator.vue?vue&type=style&index=0&id=e98a296a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e98a296a",
  null
  
)

export default component.exports